"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderFormQuestionTypeEnum = void 0;
var OrderFormQuestionTypeEnum;
(function (OrderFormQuestionTypeEnum) {
    OrderFormQuestionTypeEnum["CHECKBOX"] = "checkbox";
    OrderFormQuestionTypeEnum["EMAIL"] = "email";
    OrderFormQuestionTypeEnum["FILE"] = "file";
    OrderFormQuestionTypeEnum["NUMBER"] = "number";
    OrderFormQuestionTypeEnum["RADIO"] = "radio";
    OrderFormQuestionTypeEnum["SELECT"] = "select";
    OrderFormQuestionTypeEnum["SELECT_PRODUCT"] = "select_product";
    OrderFormQuestionTypeEnum["SWITCH"] = "switch";
    OrderFormQuestionTypeEnum["TIME"] = "time";
    OrderFormQuestionTypeEnum["TIME_INTERVAL"] = "time_interval";
    OrderFormQuestionTypeEnum["DATE"] = "date";
    OrderFormQuestionTypeEnum["DATETIME"] = "datetime";
    OrderFormQuestionTypeEnum["TEXTAREA"] = "textarea";
    OrderFormQuestionTypeEnum["TEXT"] = "text";
    OrderFormQuestionTypeEnum["HIDDEN"] = "hidden";
    OrderFormQuestionTypeEnum["SIGNATURE"] = "signature";
    OrderFormQuestionTypeEnum["PHONE"] = "phone";
    OrderFormQuestionTypeEnum["POSTAL_CODE"] = "postal_code";
})(OrderFormQuestionTypeEnum = exports.OrderFormQuestionTypeEnum || (exports.OrderFormQuestionTypeEnum = {}));
//# sourceMappingURL=order-form-question-type.js.map